module.exports = __webpack_public_path__ + "img/qiu2.1428b328.png";